// extracted by mini-css-extract-plugin
export default {"pictoAccess":"PictoAccess_pictoAccess__uVX+n"};